import { theme } from '@hover/blueprint';
import { easings } from 'react-spring';

import {
  LANDSCAPE_TOOLBAR_MENU_WIDTH,
  LANDSCAPE_TOOLBAR_WIDTH,
  TOOLBAR_HEIGHT,
} from 'src/modules/designStudio/components/Toolbar/toolBarConstants';

const BOUNCE_ANIMATION_ARRAY = [
  { bottom: 10 },
  { bottom: 0 },
  { bottom: 10 },
  { bottom: 0 },
];

const SLIDE_RIGHT_ANIMATION = {
  to: { left: LANDSCAPE_TOOLBAR_MENU_WIDTH + LANDSCAPE_TOOLBAR_WIDTH },
  config: {
    easing: easings.easeOutSine,
    duration: 300,
  },
};
const SLIDE_LEFT_ANIMATION = {
  to: { left: LANDSCAPE_TOOLBAR_WIDTH },
  config: { duration: 50 },
};
const getSlideUpAnimation = () => ({
  to: { bottom: window.innerHeight * 0.5 },
  config: {
    duration: 400,
  },
});
const SLIDE_DOWN_ANIMATION = {
  to: { bottom: TOOLBAR_HEIGHT },
  config: { duration: 300 },
};

const getButtonSlideAnimation = (
  isLandscape: boolean,
  isDesignMenuOpen: boolean,
) => {
  if (isLandscape && isDesignMenuOpen) {
    // Landscape Open Menu: slide right
    return SLIDE_RIGHT_ANIMATION;
  }
  if (isLandscape) {
    // Landscape Close Menu: slide left
    return SLIDE_LEFT_ANIMATION;
  }
  if (isDesignMenuOpen) {
    // Portrait Open Menu: slide up
    return getSlideUpAnimation();
  }
  // Portrait Close Menu: slide down
  return SLIDE_DOWN_ANIMATION;
};

const getDefaultAnimationConfig = (isLandscape: boolean) => ({
  margin: 20,
  zIndex: theme.zIndices.popover,
  left: isLandscape ? LANDSCAPE_TOOLBAR_WIDTH : 0,
  bottom: isLandscape ? 0 : TOOLBAR_HEIGHT,
});

const getButtonBounceAnimationConfig = (isLandscape: boolean) => ({
  to: isLandscape
    ? BOUNCE_ANIMATION_ARRAY
    : BOUNCE_ANIMATION_ARRAY.map(({ bottom }) => ({
        bottom: bottom + TOOLBAR_HEIGHT,
      })),
  config: {
    duration: 100,
  },
});

export {
  getButtonSlideAnimation,
  getButtonBounceAnimationConfig,
  getDefaultAnimationConfig,
};
